
export enum ValidationErrorType {
    MIN_LENGTH = 'min-length',
    LOWERCASE = 'require-lowercase',
    UPPERCASE = 'require-upercase',
    NUMBER = 'require-number',
    SPECIAL = 'require-special'
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password/password-validation-error-type.ts